
import type { Alert } from '../dashboard/queries/alerts'

import moment from 'moment/moment'
import { useEffect, useState } from 'react'

// @ts-expect-error //it's okay
import FontAwesome from 'react-fontawesome/lib'
import { Link } from 'react-router-dom'

import { useAppDispatch } from '../../store'
import { useAlerts } from '../dashboard/queries/alerts'
import { getBottomLabels, StatusHistoryProgressBar } from '../MetroProgressBar'
import { NoDataPlaceHolder } from '../PatientFolder/behavioral/components'
import { Card2, CircularProgress } from '../shared/NarusMaterial'

import { escalateAlert, getCareteam, ownAlert } from './actions'

export function Alerts (): JSX.Element {
  const alertsQuery = useAlerts()
  const alerts = alertsQuery?.data
  const loading = alertsQuery.isLoading

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div style={{ position: 'absolute' }}>
          <CircularProgress />
        </div>
      )}
      <div className='wrapper'>
        <div className='alerts'>
          {(alerts?.length ?? 0) > 0 && (
            <div className='row'>
              {alerts?.map(alert => (
                <AlertCard
                  key={`alert${alert.id}`}
                  alert={alert}
                />
              ))}
            </div>
          )}
          {(alerts?.length ?? 0) <= 0 && !loading && (
            <div className='empty-alerts'>
              <NoDataPlaceHolder
                title='There are no Alerts to display'
                className='bg-white rounded-md'
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

interface AlertProps {
  alert: Alert
}

function AlertCard ({ alert }: AlertProps): JSX.Element {
  const dispatch = useAppDispatch()
  const [ time, setTime ] = useState<string>()
  const [ owned, setOwned ] = useState<boolean>()

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(moment().clone().toISOString())
    })

    return () => {
      clearInterval(interval)
    }
  }, [])

  const name = `${alert.patient_last_name}, ${alert.patient_first_name}`

  function statusToColor (st: Alert['status']): string {
    if ([ 'new', 'l1' ].includes(st)) {
      return 'green'
    }

    if ([ 'l2', 'l3' ].includes(st)) {
      return 'orange'
    }

    if ([ 'l4', 'l5' ].includes(st)) {
      return 'red'
    }

    return 'red'
  }

  function isL5 (st: Alert['status']): boolean {
    return st === 'l5'
  }

  function ownedFn (): void {
    if (owned) {
      return
    }
    ownAlert(alert.id)
      .catch((e) => {
        console.error(e)
      })
    setOwned(true)
  }

  return (
    <div className='col-xs-12 col-sm-6 col-md-4'>
      <Card2
        title={(
          <Link to={`/patient/${alert.client_name}/${alert.patient_id}/patientFolder`}>
            {name}
          </Link>
        )}
        subtitle={alert.title.replace(/->/g, '→')}
        label={status.toUpperCase()}
        cardTextColor={statusToColor(alert.status)}
        actions={[
          {
            label: 'OWN',
            callback: () => ownedFn()
          },
          isL5(alert.status)
            ? {}
            : {
              label: 'ESCALATE',
              callback: async () => await escalateAlert(alert.id)
            }
        ]}
      >
        <div className='progressbar-stack'>
          <StatusHistoryProgressBar
            statusHistory={alert.status_history}
            myStatus='l1'
            startLabel='L1'
            currentTime={time}
          />
          <StatusHistoryProgressBar
            statusHistory={alert.status_history}
            startLabel='L2'
            myStatus='l2'
            currentTime={time}
          />
          <StatusHistoryProgressBar
            startLabel='L4'
            endLabel='L5'
            statusHistory={alert.status_history}
            myStatus='l4'
            currentTime={time}
          />
        </div>
        <div className='progressbar-stack-labels'>
          <h4>{getBottomLabels(alert.status_history).start}</h4>
          <h4>{getBottomLabels(alert.status_history).end}</h4>
        </div>
        <button
          type='button'
          className='mt-4 float-right text-black text-opacity-75 hover:text-opacity-40 transition-colors'
          onClick={() => {
            dispatch(getCareteam(alert.meta.careTeam))
          }}
        >
          <FontAwesome name='users' />
          {' '}
          Care Team
        </button>
      </Card2>
    </div>
  )
}
